import * as yup from 'yup';
import { AuthSignUpPayload } from '../interfaces/AuthSignUpPayload';

export const authSignUpValidator: yup.SchemaOf<AuthSignUpPayload> = yup
  .object()
  .shape({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    middleName: yup.string().optional(),
    phone: yup.string().required(),
  });
